import pythonApiClient from "./pythonBaseApi";

const tiposValorizacionHoteleriaApi = {
  list: (soloActivos = false) =>
    pythonApiClient.get("/mantenimientos/hoteleria/tipos-valorizacion/", {
      params: { solo_activos: soloActivos },
    }),

  getById: (id) =>
    pythonApiClient.get(`/mantenimientos/hoteleria/tipos-valorizacion/${id}`),

  create: (data) =>
    pythonApiClient.post("/mantenimientos/hoteleria/tipos-valorizacion/", data),

  update: (id, data) =>
    pythonApiClient.put(
      `/mantenimientos/hoteleria/tipos-valorizacion/${id}`,
      data
    ),

  remove: (id) =>
    pythonApiClient.delete(`/mantenimientos/hoteleria/tipos-valorizacion/${id}`),
};

export default tiposValorizacionHoteleriaApi;
